/* JOLI POT, petits correctifs d'affichage (assets/jp-correctifs.js), 24/10/2026.
   Chargé par layout/theme.liquid sur les fiches produit et la page du bon de commande pro, après les scripts de la page.
   Pourquoi un fichier à part : assets/jp-configurateur.js (118 Ko) et assets/jp-bon-commande.js (143 Ko) sont trop gros pour l'API.
   1. Configurateur : le message d'erreur de la carte à planter perd son emoji (« … carte à planter. »).
   2. Bon de commande pro : la Finlande est retirée de la liste des pays (décision de Mylène, 24/10/2026).
   3. 27/10/2026, configurateur sur mobile : tant que « Ajouter au panier » n'est pas encore disponible, la barre du bas propose un bouton
      « Continuer » (ou « Écrire mon message ») qui amène à l'étape en cours. Avant : barre sans bouton, il fallait chercher la suite.
      Phrase d'aide au-dessus du bouton reformulée de façon plus engageante. */
(function () {
  var EMOJI = /\s*💌\s*$/;
  var PAYS_RETIRES = ['FI'];
  function erreur(el) {
    if (el && el.textContent && EMOJI.test(el.textContent)) el.textContent = el.textContent.replace(EMOJI, '.');
  }
  function pays() {
    var s = document.getElementById('jpb-pays');
    if (!s) return;
    PAYS_RETIRES.forEach(function (c) {
      var o = s.querySelector('option[value="' + c + '"]');
      if (!o) return;
      var choisi = o.selected;
      o.parentNode.removeChild(o);
      if (choisi) { s.value = 'FR'; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function tout() {
    pays();
    document.querySelectorAll('.jp-erreur').forEach(erreur);
  }
  tout();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  if (!('MutationObserver' in window)) return;
  new MutationObserver(function (liste) {
    for (var i = 0; i < liste.length; i++) {
      var ajout = liste[i].addedNodes;
      for (var j = 0; j < ajout.length; j++) {
        var n = ajout[j];
        if (n.nodeType !== 1) continue;
        if (n.classList.contains('jp-erreur')) erreur(n);
        if (n.tagName === 'OPTION' && n.parentNode && n.parentNode.id === 'jpb-pays') pays();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
(function () {
  if (!document.getElementById('jp-config') || !('MutationObserver' in window)) return;
  var AIDE = {
    "Choisissez vos options, le bouton d'achat apparaîtra ensuite.": 'Encore quelques choix, et votre pot sera prêt à ajouter au panier.',
    "Écrivez ou choisissez votre message pour accéder au bouton d'achat.": 'Dernière étape : écrivez ou choisissez votre message.'
  };
  var suite = null, raf = 0;
  function cible() {
    var e = document.querySelector('.ProductForm__Option.jp-attente');
    if (e && e.offsetParent !== null) return { el: e, txt: 'Continuer' };
    var t = document.getElementById('votre-texte-personnalise');
    if (t && t.offsetParent !== null && !t.value.trim()) return { el: t.closest('.ProductForm__Label') || t, txt: 'Écrire mon message', champ: t };
    return null;
  }
  function aller() {
    var c = cible(); if (!c) return;
    /* le configurateur bloque le défilement 2,5 s après un choix : un geste de défilement le libère */
    try { window.dispatchEvent(new Event('wheel')); } catch (e) {}
    window.scrollTo({ top: c.el.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    if (c.champ) setTimeout(function () { try { c.champ.focus({ preventScroll: true }); } catch (e) {} }, 600);
  }
  function maj() {
    raf = 0;
    aide(); extras();
    var b = document.querySelector('.jp-barre-mob'), o = b && b.querySelector('.jp-barre-mob__btn');
    if (!o) return;
    if (!suite) {
      var st = document.createElement('style');
      st.textContent = '.jp-barre-mob .jp-barre-mob__suite{padding-left:14px;padding-right:14px;white-space:nowrap}.jp-barre-mob:has(.jp-barre-mob__suite:not([hidden])) .jp-barre-mob__prix strong{font-size:15px;white-space:nowrap}';
      document.head.appendChild(st);
      suite = document.createElement('button'); suite.type = 'button'; suite.className = 'jp-barre-mob__btn jp-barre-mob__suite'; suite.hidden = true;
      suite.addEventListener('click', aller);
      o.insertAdjacentElement('afterend', suite);
      new MutationObserver(plusTard).observe(o, { attributes: true, attributeFilter: ['hidden'] });
    }
    var c = o.hidden ? cible() : null;
    suite.hidden = !c; if (c && suite.textContent !== c.txt) suite.textContent = c.txt;
  }
  function plusTard() { if (!raf) raf = requestAnimationFrame(maj); }
  /* 28/10/2026 : sur mobile, les petits plus défilent de côté (le configurateur leur impose display:grid en ligne, remplacé ici par flex) */
  function extras() {
    var x = document.querySelector('.jp-plus .jp-extras'); if (!x || !window.matchMedia('(max-width:699px)').matches) return;
    if (x.style.getPropertyValue('display') === 'grid') x.style.setProperty('display', 'flex', 'important');
    if (!x._jpo) { x._jpo = new MutationObserver(extras); x._jpo.observe(x, { attributes: true, attributeFilter: ['style'] }); }
  }
  /* 28/10/2026 : la phrase d'aide dit où l'on en est (« Étape 1 : choisissez votre modèle. ») */
  var aideObs = null;
  function aide() {
    var a = document.getElementById('jp-aide-etapes'); if (!a) return;
    if (!aideObs) { aideObs = new MutationObserver(aide); aideObs.observe(a, { childList: true, characterData: true, subtree: true }); }
    var t = a.textContent;
    if (t === "Écrivez ou choisissez votre message pour accéder au bouton d'achat.") { a.textContent = AIDE[t]; return; }
    if (t !== "Choisissez vos options, le bouton d'achat apparaîtra ensuite." && !/^(Encore quelques choix|Étape \d+ :)/.test(t)) return;
    var e = document.querySelector('.ProductForm__Option.jp-attente'), l = e && e.querySelector('.ProductForm__Label');
    var lt = l ? l.textContent.replace(/\s+/g, ' ').trim() : '', m = lt.match(/^(\d+)\s*(.+)$/), v;
    if (m) v = 'Étape ' + m[1] + ' : ' + m[2].charAt(0).toLowerCase() + m[2].slice(1).replace(/[\s.:]+$/, '') + '.';
    else v = AIDE["Choisissez vos options, le bouton d'achat apparaîtra ensuite."];
    if (a.textContent !== v) a.textContent = v;
  }
  ['change', 'input', 'click'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(plusTard, 50); }, true); });
  new MutationObserver(plusTard).observe(document.body, { childList: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plusTard); else plusTard();
  setTimeout(plusTard, 1500);
})();
/* 5. 28/10/2026, configurateur et fiches d'occasion sur mobile : bouton flottant « Voir l'aperçu », comme sur Entreprise et Événement.
   Il apparaît quand l'aperçu du pot (.jp-ap) ou de la carte (.jp-ca) est rempli mais sorti de l'écran, pendant que l'on est dans le configurateur,
   et l'ouvre en grand dans une fenêtre (copie de l'aperçu, mise à jour à chaque ouverture). Au-dessus de la barre du bas quand elle est là. */
(function () {
  var b = null, ouvert = false, raf = 0, vus = [], formVu = false, aps = [], zone = null, io = null;
  function scan() { [].forEach.call(document.querySelectorAll('.jp-ap, .jp-ca'), function (a) { if (aps.indexOf(a) < 0) { aps.push(a); vus.push(false); io.observe(a); } }); }
  function actifs() { return aps.filter(function (a) { return !a.hidden && a.getBoundingClientRect().height > 0; }); }
  function maj() {
    raf = 0; if (!b) return; scan();
    var act = actifs(), unVu = aps.some(function (a, i) { return vus[i] && !a.hidden; });
    var barre = document.querySelector('.jp-barre-mob.is-visible');
    b.style.bottom = barre ? 'calc(' + (barre.offsetHeight + 14) + 'px)' : '';
    b.hidden = !(window.innerWidth < 900 && formVu && act.length && !unVu && !ouvert);
  }
  function plusTard() { if (!raf) raf = requestAnimationFrame(maj); }
  function fermer(f) { f.remove(); ouvert = false; document.documentElement.style.overflow = ''; maj(); b.focus({ preventScroll: true }); }
  function ouvrir() {
    var f = document.createElement('div'); f.className = 'jp-voir-fen'; f.setAttribute('role', 'dialog'); f.setAttribute('aria-modal', 'true'); f.setAttribute('aria-label', "Aperçu de votre Joli Pot");
    var boite = document.createElement('div'); boite.className = 'jp-voir-fen__boite';
    actifs().forEach(function (a) {
      var o = a.querySelector('.jp-ap__scene') || a.querySelector('.jp-ca__carte') || a, c = o.cloneNode(true);
      c.style.width = o.offsetWidth + 'px'; c.style.maxWidth = '100%';
      var co = o.querySelectorAll('canvas'), cc = c.querySelectorAll('canvas');
      for (var i = 0; i < co.length; i++) { try { cc[i].width = co[i].width; cc[i].height = co[i].height; cc[i].getContext('2d').drawImage(co[i], 0, 0); } catch (e) {} }
      boite.appendChild(c);
    });
    var n = document.createElement('p'); n.className = 'jp-voir-fen__note'; n.textContent = "Aperçu indicatif : chaque pot est décoré à la main."; boite.appendChild(n);
    var x = document.createElement('button'); x.type = 'button'; x.className = 'jp-voir-fen__x'; x.setAttribute('aria-label', 'Fermer'); x.textContent = '×'; boite.appendChild(x);
    f.appendChild(boite);
    f.addEventListener('click', function (e) { if (e.target === f || e.target === x) fermer(f); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape' && f.isConnected) { fermer(f); document.removeEventListener('keydown', esc); } });
    ouvert = true; maj(); document.body.appendChild(f); document.documentElement.style.overflow = 'hidden'; x.focus();
  }
  function init() {
    var a0 = document.querySelector('.jp-ap, .jp-ca');
    if (!a0 || b || !('IntersectionObserver' in window) || document.getElementById('jpe-voir')) return;
    zone = a0.closest('form') || a0.parentNode;
    var st = document.createElement('style');
    st.textContent = '.jp-voir{position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:9991;display:inline-flex;align-items:center;gap:8px;padding:12px 20px;border:0;border-radius:999px;background:#0c381c;color:#fff;font-family:"JP Orwell Brut","Courier New",monospace;font-size:13px;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;box-shadow:0 6px 20px rgba(20,30,22,.28);cursor:pointer}'
      + '.jp-voir[hidden]{display:none!important}@media (min-width:900px){.jp-voir{display:none!important}}'
      + '.jp-voir-fen{position:fixed;inset:0;z-index:2147482001;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(20,30,22,.6)}'
      + '.jp-voir-fen__boite{position:relative;display:flex;flex-direction:column;align-items:center;gap:12px;width:100%;max-width:420px;max-height:calc(100vh - 32px);overflow:auto;padding:44px 16px 16px;border-radius:14px;background:#fbf4ea}'
      + '.jp-voir-fen__boite>*{margin:0}.jp-voir-fen__note{font-size:12.5px;font-style:italic;opacity:.75;text-align:center}'
      + '.jp-voir-fen .jp-voir-fen__x{position:absolute;top:8px;right:8px;width:36px;height:36px;border:0;border-radius:50%;background:#fff;color:#57200b;font-size:22px;line-height:1;cursor:pointer}';
    document.head.appendChild(st);
    b = document.createElement('button'); b.type = 'button'; b.className = 'jp-voir'; b.hidden = true;
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>' + "Voir l'aperçu";
    b.addEventListener('click', ouvrir);
    document.body.appendChild(b);
    io = new IntersectionObserver(function (en) { en.forEach(function (e) { var i = aps.indexOf(e.target); if (i > -1) vus[i] = e.isIntersecting; }); plusTard(); }, { threshold: 0.15 });
    aps = []; scan();
    new IntersectionObserver(function (en) { formVu = en[0].isIntersecting; plusTard(); }).observe(zone);
    window.addEventListener('scroll', plusTard, { passive: true }); window.addEventListener('resize', plusTard);
    document.addEventListener('input', plusTard, true); document.addEventListener('change', plusTard, true);
  }
  var essais = 0;
  (function attendre() { init(); if (!b && ++essais < 20) setTimeout(attendre, 500); })();
})();
/* 6. 28/10/2026, Entreprise et Événement : comme dans le configurateur, tant que le bouton d'ajout de la barre du bas n'est pas disponible,
   un bouton « Écrire mon message », « Ajouter mon logo », « Choisir la quantité »… amène à ce qui manque (champ visible et vide, dans l'ordre de la page). */
(function () {
  var raf = 0, suite = null;
  function $(id) { return document.getElementById(id); }
  function vu(el) { return !!el && el.offsetParent !== null && !el.closest('[hidden]'); }
  function vide(el) { return el.type === 'file' ? !(el.files && el.files.length) : !String(el.value || '').trim(); }
  function cible() {
    var L = [['jpe-fichier', 'Ajouter mon logo'], ['jpe-msg', 'Écrire mon message'], ['jpe-vmsg', 'Écrire le verso'], ['jpe-liste', 'Coller les prénoms'], ['jpe-cmsg', 'Écrire la carte']];
    for (var i = 0; i < L.length; i++) { var el = $(L[i][0]); if (vu(el) && vide(el)) { if (L[i][0] === 'jpe-msg' && vu($('jpe-fichier'))) continue; return { el: el, txt: L[i][1] }; } }
    var q = $('jpe-qte'); return q ? { el: q, txt: 'Choisir la quantité' } : null;
  }
  function aller() {
    var c = cible(); if (!c) return;
    (c.el.closest('.jpe-etape') || c.el).scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (c.el.type !== 'file') setTimeout(function () { try { c.el.focus({ preventScroll: true }); } catch (e) {} }, 450);
  }
  function maj() {
    raf = 0;
    var b = document.querySelector('.jpe-barre'), o = b && b.querySelector('.jpe-barre__btn:not(.jpe-barre__suite)');
    if (!o) return;
    if (!suite) {
      suite = document.createElement('button'); suite.type = 'button'; suite.className = 'jpe-barre__btn jpe-barre__suite'; suite.hidden = true;
      suite.addEventListener('click', aller); o.insertAdjacentElement('afterend', suite);
      new MutationObserver(plusTard).observe(o, { attributes: true, attributeFilter: ['hidden'] });
      var st = document.createElement('style'); st.textContent = '.jpe-barre .jpe-barre__suite{white-space:nowrap}@media (max-width:749px){.jpe-barre .jpe-barre__suite{padding:13px 14px}}'; document.head.appendChild(st);
    }
    var c = o.hidden ? cible() : null;
    suite.hidden = !c; if (c && suite.textContent !== c.txt) suite.textContent = c.txt;
  }
  function plusTard() { if (!raf) raf = requestAnimationFrame(maj); }
  if (!document.getElementById('jpe-form')) return;
  ['input', 'change', 'click'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(plusTard, 60); }, true); });
  new MutationObserver(plusTard).observe(document.body, { childList: true });
  setTimeout(plusTard, 800); setTimeout(plusTard, 2500);
})();
/* 7. 28/10/2026 (validé par Mylène) : sur mobile, quand la barre d'achat du bas est visible dans un configurateur (B2C, Entreprise, Événement),
   la flèche « Revenir en haut » et la pastille Jolis Points (BON) s'effacent : il ne reste que la barre, « Voir l'aperçu » et la bulle d'aide. */
(function () {
  var st = document.createElement('style');
  st.textContent = '@media (max-width:899px){html.jpe-barre-on :is(.jp-haut,#bon-loyalty-btn,.jp-bon-lanceur),body:has(.jp-barre-mob.is-visible:not(.jpc-barre)) :is(.jp-haut,#bon-loyalty-btn,.jp-bon-lanceur){opacity:0!important;visibility:hidden!important;pointer-events:none!important}}';
  document.head.appendChild(st);
})();

/* 29/10/2026 : « Lire la suite » réutilisable. Tout bloc .jp-lirelasuite est replié sur mobile (≤ 699 px) à environ 6 lignes avec un fondu,
   suivi d'un petit lien-bouton « Lire la suite » / « Réduire » (aria-expanded). Le texte entier reste dans la page (référencement).
   Ordinateur : rien de replié, bouton masqué. Styles : assets/jp-socle-fin.css. Nombre de lignes réglable par bloc : style="--jp-lls-lignes:8". */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width:699px)') : null, n = 0;
  function prep(b) {
    if (b.getAttribute('data-jp-lls')) return;
    b.setAttribute('data-jp-lls', '1');
    if (!b.id) b.id = 'jp-lls-' + (++n);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'jp-lls-btn'; btn.hidden = true;
    btn.setAttribute('aria-controls', b.id); btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Lire la suite';
    btn.addEventListener('click', function () {
      var ouvert = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      btn.textContent = ouvert ? 'Lire la suite' : 'Réduire';
      b.classList.toggle('is-replie', ouvert);
      if (ouvert) { var r = b.getBoundingClientRect(); if (r.top < 0) window.scrollBy(0, r.top - 90); }
    });
    b.parentNode.insertBefore(btn, b.nextSibling);
    b._jpLls = btn;
  }
  function maj() {
    document.querySelectorAll('.jp-lirelasuite').forEach(function (b) {
      prep(b);
      var btn = b._jpLls;
      if (!mq || !mq.matches) { b.classList.remove('is-replie'); btn.hidden = true; return; }
      if (btn.getAttribute('aria-expanded') === 'true') return;
      b.classList.add('is-replie');
      var trop = b.scrollHeight > b.clientHeight + 8;
      if (!trop) b.classList.remove('is-replie');
      btn.hidden = !trop;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj); else maj();
  window.addEventListener('load', maj);
  if (mq && mq.addEventListener) mq.addEventListener('change', maj);
})();

/* 29/10/2026 : légende de l'aperçu (configurateurs Entreprise et Événement, .jpe-apercu__note) : retour à la ligne mobile avant « est décorée »
   pour les vieux iOS sans text-wrap:balance (« Aperçu indicatif, chaque pièce » / « est décorée à la main. »). Texte enregistré inchangé. */
(function () {
  function maj() {
    document.querySelectorAll('.jpe-apercu__note').forEach(function (p) {
      if (p.querySelector('.jp-br-mob') || p.children.length) return;
      var t = p.textContent, i = t.indexOf('chaque pièce est ');
      if (i < 0) return;
      var a = t.slice(0, i + 'chaque pièce'.length), b = t.slice(i + 'chaque pièce'.length);
      p.textContent = a; var br = document.createElement('br'); br.className = 'jp-br-mob'; p.appendChild(br); p.appendChild(document.createTextNode(b));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj); else maj();
})();

/* 29/10/2026 : pages Cadeau entreprise et Cadeaux invités (sections jp-entreprise et jp-evenement, pas les pages occasion) :
   la date limite (#jpe-limite, remplie par le moteur de dates, clé noel_entreprise côté entreprise) passe en tampon à cheval
   sur le bas de la photo du haut de page. Sans photo, elle reste au-dessus du bouton, centrée. Styles : assets/jp-socle-fin.css. */
(function () {
  function maj() {
    document.querySelectorAll('.jpe:not(.jpo) .jpe-hero').forEach(function (h) {
      var l = h.querySelector('#jpe-limite, .jpe-limite'), ph = h.querySelector('.jpe-hero__photo');
      if (!l || !ph || !ph.querySelector('img') || l.parentNode === ph) return;
      ph.classList.add('jp-ph-tampon'); ph.appendChild(l); l.classList.add('jp-limite-tampon');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj); else maj();
})();
